import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { ToastModule } from 'primeng/toast';
import { MxEnsureModuleLoadedOnceGuard } from '../../mx.ensure-module-loaded-once.guard';

import { MxToastComponent } from './mx.toast.component';

@NgModule({
  imports: [CommonModule, ToastModule, I18NextModule],
  exports: [MxToastComponent],
  declarations: [MxToastComponent],
})
export class MxToastModule extends MxEnsureModuleLoadedOnceGuard {
  // Ensure that OverlayModule is only loaded into AppModule

  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(@Optional() @SkipSelf() parentModule: MxToastModule) {
    super(parentModule, 'CoreModule');
  }
}
